import {
  aVisitInsightPage,
  mockVisitInsightPageOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockVisitInsightPageOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          visitInsightPage: aVisitInsightPage(),
        },
      });
    }
  ),
];
